/**
 * Lifted from `@parrot/utils` (intelligence-platform-monorepo, libs/utils).
 *
 * Copied rather than imported because that package is `private` and published
 * only inside the pnpm workspace — see docs/AUDIT_FE_STANDARDS.md. It is ten
 * lines with no dependencies, so a copy costs less than the migration would.
 *
 * Keep it identical to upstream. Anything cleverer belongs upstream, not here.
 */

/**
 * Joins truthy class names with a single space. Falsy values (`false`, `null`,
 * `undefined`, `''`) are dropped, so the common conditional idioms compose
 * cleanly:
 *
 *   cx(styles.base, className)                    // optional passthrough
 *   cx(styles.item, isActive && styles.active)    // conditional class
 */
export function cx(...values: (string | false | null | undefined)[]): string {
  return values.filter((value): value is string => Boolean(value)).join(' ');
}
